import { ChartSettingsV2MenuItems } from '@thoughtspot/chart-lib/lib/config/chart-settings-v2';
import { getCustomPropsConfig } from '@thoughtspot/chart-lib/lib/core/chart-allowed-configurations-config';
import { getChartType } from '@thoughtspot/chart-lib/lib/core/chart-model-utils';
import {
    configOptions,
    isCustomPropDisplayed,
} from '@thoughtspot/chart-lib/lib/core/chart-type-specification-service';
import { i18nKeys } from '@thoughtspot/i18n';
import { isChartSettingsV2Enabled } from '@thoughtspot/session-service';
import _ from 'lodash';
import { AnswerEditPanelComponents } from '/@services/answer/answer.util';
import {
    AnswerColumn,
    AxisConfig,
    ChartViz,
    DisplayMode,
} from '/@services/generated/graphql-types';

export enum VizEditorComponents {
    CHART_EDITOR,
    TABLE_EDITOR,
    COLUMN_EDITOR,
    AXIS_EDITOR,
    TABLE_COLUMN_CONDITION_EDITOR,
    SUMMARY_CONDITION_EDITOR,
    CHART_COLUMN_CONDITION_EDITOR,
}

export enum VizEditorTab {
    CONFIGURE = 'configure',
    SETTINGS = 'settings',
}

export const VizEditorLabels: Partial<Record<DisplayMode, i18nKeys>> = {
    [DisplayMode.ChartMode]: 'editPanel.titles.CHART_EDITOR',
    [DisplayMode.TableMode]: 'editPanel.titles.TABLE_EDITOR',
};

export function findColumnFromAxisConfig(
    axisConfig: AxisConfig,
    columnId: string,
) {
    const keys = Object.keys(axisConfig);
    let arr: AnswerColumn[] = [];
    keys.forEach(key => {
        arr = arr.concat(axisConfig[key as keyof AxisConfig] || ([] as any));
    });

    return arr.find((column: AnswerColumn) => column.id === columnId);
}

export function shouldShowAdvancedSettings(chartModel: ChartViz) {
    const config = configOptions(getChartType(chartModel), chartModel)
        .allowedConfigurations;
    const hasConfigToDisplay = _.some(
        Object.values(config.advanced?.display),
        isDisplayed => {
            return isDisplayed === true;
        },
    );
    if (hasConfigToDisplay) {
        return true;
    }

    const customProps = getCustomPropsConfig(config);
    return _.some(customProps, customProp =>
        isCustomPropDisplayed(customProp, chartModel),
    );
}

export const getLayoutPanelState = () => {
    return isChartSettingsV2Enabled()
        ? ChartSettingsV2MenuItems.LAYOUT
        : AnswerEditPanelComponents.VIZ_EDITOR;
};

export const getAxisPanelState = () => {
    return isChartSettingsV2Enabled()
        ? ChartSettingsV2MenuItems.AXIS
        : AnswerEditPanelComponents.VIZ_EDITOR;
};

export const getColumnPanelState = () => {
    return isChartSettingsV2Enabled()
        ? ChartSettingsV2MenuItems.COLUMN
        : AnswerEditPanelComponents.VIZ_EDITOR;
};
